import TagsReducer from "./reducer";

export const setTagsList = (payload) => (dispatch) => {
  dispatch(TagsReducer.actions.setTagsList(payload));
};

export const setSelectTag = (payload) => (dispatch) => {
  dispatch(TagsReducer.actions.setSelectTag(payload));
};

export const addTagToList = (payload) => (dispatch) => {
  dispatch(TagsReducer.actions.addList(payload));
};

export const updateTagsList = (payload) => (dispatch) => {
  dispatch(TagsReducer.actions.updateTagsList(payload));
};

export const clearSelectedTag = () => (dispatch) => {
  dispatch(TagsReducer.actions.clearSelectItems());
};

export const openCreateTagModal = () => (dispatch) => {
  dispatch(TagsReducer.actions.openCreateTagModal());
};

export const openSelectTagsModal = () => (dispatch) => {
  dispatch(TagsReducer.actions.openSelectTagsModal());
};

export const setSelectedTags = (payload) => (dispatch) => {
  dispatch(TagsReducer.actions.setSelectedTags(payload));
};

export const closeCreateTagModal = (payload) => (dispatch) => {
  dispatch(TagsReducer.actions.closeCreateTagModal(payload));
};

export const closeSelectTagsModal = () => (dispatch) => {
  dispatch(TagsReducer.actions.closeSelectTagsModal());
};

export const clearNewTag = () => (dispatch) => {
  dispatch(TagsReducer.actions.clearNewTag());
};
